import { RacemapColors } from '@racemap/utilities/consts/common';
import { OneSecondInMillis } from '@racemap/utilities/consts/time';
import type { TableCellProps } from 'react-virtualized';
import {
  type ManagedTracker,
  TrackerColumnKeys,
} from '../../../../store/trackers/trackers_reducers';
import { Columns } from '../../../DataTable';
import { IconCheckCircle, IconFailCircle } from '../../../Icon';
import { IntervalCell } from './IntervalCell';

interface CellProps extends TableCellProps {
  cellData?: ManagedTracker['state'];
  rowData: ManagedTracker;
}

export const InfoReportColumn = () => {
  const cellRenderer = ({ rowData }: CellProps) => {
    if (!rowData.setting?.infoReportEnabled || !rowData.setting?.infoReportInterval) {
      return <IntervalCell icon={<IconFailCircle color={RacemapColors.BaseRed} />} />;
    }

    return (
      <IntervalCell
        intervalInMillis={rowData.setting?.infoReportInterval * OneSecondInMillis}
        icon={<IconCheckCircle color={RacemapColors.DarkGreen} />}
      />
    );
  };

  return Columns.sortingColumn({
    dataKey: TrackerColumnKeys.INFO_REPORT,
    label: 'Info Report',
    cellRenderer,
    minWidth: 115,
    columnData: { hiddenOnDefault: true },
    sortingMethod: (_cA, _cB, rowDataA: ManagedTracker, rowDataB: ManagedTracker) => {
      if (!rowDataA.setting && !rowDataB.setting) return 0;
      const { infoReportEnabled: infoReportEnabledA, infoReportInterval: infoReportIntervalA } =
        rowDataA.setting ?? {};
      const { infoReportEnabled: infoReportEnabledB, infoReportInterval: infoReportIntervalB } =
        rowDataB.setting ?? {};

      if (!infoReportEnabledA) return 1;
      if (!infoReportEnabledB) return -1;

      const intervalA = infoReportIntervalA ?? Number.POSITIVE_INFINITY;
      const intervalB = infoReportIntervalB ?? Number.POSITIVE_INFINITY;
      return intervalA - intervalB;
    },
  });
};
